function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 3C13.25 3 10.455 1.592 8.6 0.200001C8.245 -0.0679995 7.755 -0.0679995 7.4 0.200001C5.545 1.592 2.75 3 1 3C0.448 3 0 3.447 0 4C0 9.584 2.701 13.817 7.606 15.919C7.732 15.973 7.866 16 8 16C8.134 16 8.268 15.973 8.394 15.919C13.299 13.817 16 9.584 16 4C16 3.447 15.552 3 15 3ZM8 13.904V8H2.616C2.298 7.048 2.095 6.019 2.027 4.907C3.955 4.582 6.236 3.445 8 2.23V8H13.384C12.506 10.634 10.694 12.643 8 13.904Z",
  fill: "#002A95"
});

var SvgPolicy = function SvgPolicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Policy.1d7a961a.svg";
export { ForwardRef as ReactComponent };